/* import __COLOCATED_TEMPLATE__ from './free-trial-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();